import { LOG_OUT } from "../login/action";
import { SET_CIATATION_PDF_STATES } from "./action";

export const defaultState={
    driverCitationPDFStateList:{}
}

function driverCitationPDFReducer(state=defaultState,action){
    switch (action.type) {
       case SET_CIATATION_PDF_STATES:
           return{
               ...state,
               driverCitationPDFStateList:action.payload
           }
        case LOG_OUT:
            return defaultState;
        default:
          return state;
      }
}

export default driverCitationPDFReducer;